<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <strong>{{ this.titlePage }}</strong>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="campaignName"
                label="Campaign Name"
                color="red darken-1"
                required
              ></v-text-field>
              <v-text-field
                v-model="campaignDesc"
                label="Campaign Description"
                color="red darken-1"
                required
              ></v-text-field>            
              <v-autocomplete
                v-model="bisnis"
                :items="arrBisnis"
                item-value="BISNIS_DESC"
                item-text="BISNIS_DESC"
                :return-object="true"
                label="Bisnis"
                color="red darken-1"
                 @change="getProduct()"
              ></v-autocomplete>

              <template>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-combobox
                          v-model="dateRangeText"
                          multiple
                          chips
                          small-chips
                          label="Period"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-combobox>
                      </template>
                      <v-date-picker
                        v-model="dates"
                        multiple
                        no-title
                        scrollable
                        range
                        :min="minDate"
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="menu = false"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(dates)"
                        >
                          OK
                        </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </template>

              <v-autocomplete
                v-model="empType"
                :items="arrEmployeeType"
                item-value="EMPLOYEE_TYPE_CODE"
                item-text="EMPLOYEE_TYPE_CODE"
                label="Salesman"
                color="red darken-1"
                  @change="getTitle()"
              ></v-autocomplete>
              <v-text-field
                v-model="title" 
                label="Title"
                color="red darken-1"
                @click="dialogTitle = true"
                :append-outer-icon="'mdi-magnify'"
                @click:append-outer="dialogTitle = true"
                 @input="reversedMessageTitle"
                readonly
              ></v-text-field>
                <v-text-field
                v-model="branch" 
                label="Branch"
                color="red darken-1"
                :append-outer-icon="'mdi-magnify'"
                @click:append-outer="dialogBranch = true"
                 @click="dialogBranch = true"
                 @input="reversedMessageBranch"
                readonly
              ></v-text-field>
               <v-text-field
                v-model="channel"
                label="Sales Channel Group"
                color="red darken-1"
                :append-outer-icon="'mdi-magnify'"
                @click:append-outer="dialogChannel = true"
                @click="dialogChannel = true"
                @input="reversedMessageChannel"
                readonly
              ></v-text-field> 
                     
               <v-checkbox
                v-model="isPicture"
                label="Is Picture"
                value="1"
              ></v-checkbox>
               <v-file-input
                  v-model="JSON_FILE_UPLOAD"
                  color="red darken-1"
                  counter
                  label="Upload Customer"
                  placeholder="Select your files"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  @change="onAddFiles($event)"/>

                  <v-btn small color="warning" @click="downloadCSV()">Download Template Upload Customer</v-btn>
            </v-form>
          </v-card>
     
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <strong>Activity</strong>
             <template>
              <div class="test-survey-builder">
                <div v-if="addQuestion">
                  <SurveyBuilder :options="sampleQuestion" />
                </div>
                <div class="d-flex justify-center">
                  <v-btn @click="addNewQuestion()" small class="mx-1" color="warning">Add Question</v-btn>
                </div>
                <div class="row">
                <QuestionsView :questions="questionsList" :readOnly="true" />
                </div>
              </div>
              <div class="mt-8">
								<v-btn @click="submit" block color="success">S U B M I T</v-btn>
							</div>
            </template>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

 <!--dialog title new-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogTitle"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="title"
              :headers="headersTitle"
              :items="arrTitle"
              :search="search"
              item-key="TITTLE_CODE"
              show-select
              class="elevation-1"
              disable-pagination
              hide-default-footer
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>


<!--dialog TItle-->
    <!-- <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogTitle"
          scrollable
          max-width="300px"
        >
          <v-card>
            <v-card-title>Select Title</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">
              
          <v-list-item-group
            v-model="title"
            multiple
          >
            <template v-for="(item, i) in arrTitle">
              <v-divider
                v-if="!item.TITTLE_CODE"
                :key="`divider-${i}`"
              ></v-divider>

              <v-list-item
                v-else
                :key="`item.TITTLE_CODE-${i}`"
                :value="item.TITTLE_CODE"
                active-class="deep-purple--text text--accent-4"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.TITTLE_CODE"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="deep-purple accent-4"
                    ></v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-col class="text-right">
              <v-btn
                color="blue darken-1"
                text
                @click="dialogTitle = false"
              >
                Close
              </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template> -->


    <!--dialog Branch-->

    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogBranch"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="branch"
              :headers="headersBranch"
              :items="arrBranch"
              :search="search"
              item-key="BRANCH_CODE"
              show-select
              class="elevation-1"
              disable-pagination
              hide-default-footer
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>
    <!-- <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogBranch"
          scrollable
          max-width="300px"
        >
          <v-card>
            <v-card-title>Select Branch</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">
              
          <v-list-item-group
            v-model="branch"
            multiple
          >
            <template v-for="(item, i) in arrBranch">
              <v-divider
                v-if="!item.BRANCH_CODE"
                :key="`divider-${i}`"
              ></v-divider>

              <v-list-item
                v-else
                :key="`item.BRANCH_CODE-${i}`"
                :value="item.BRANCH_CODE"
                active-class="deep-purple--text text--accent-4"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.BRANCH_CODE"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="deep-purple accent-4"
                    ></v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-col class="text-right">
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogBranch = false"
                  >
                    Close
                  </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template> -->

     <!--dialog Channel-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogChannel"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="channel"
              :headers="headersChannel"
              :items="arrSalesChannelGroup"
              :search="search"
              item-key="SALES_CHANNEL_GROUP"
              show-select
              class="elevation-1"
              disable-pagination
              hide-default-footer
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>
    <!-- <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogChannel"
          scrollable
          max-width="500px"
        >
          <v-card>
            <v-card-title>Select Sales Channel Group</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">
              
          <v-list-item-group
            v-model="channel"
            multiple
          >
            <template v-for="(item, i) in arrSalesChannelGroup">
              <v-divider
                v-if="!item.SALES_CHANNEL_GROUP"
                :key="`divider-${i}`"
              ></v-divider>

              <v-list-item
                v-else
                :key="`item.SALES_CHANNEL_GROUP-${i}`"
                :value="item.SALES_CHANNEL_GROUP"
                active-class="deep-purple--text text--accent-4"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.SALES_CHANNEL_GROUP"></v-list-item-title>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-checkbox
                      :input-value="active"
                      color="deep-purple accent-4"
                    ></v-checkbox>
                  </v-list-item-action>
                </template>
              </v-list-item>
            </template>
          </v-list-item-group>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-col class="text-right">
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogChannel = false"
                  >
                    Close
                  </v-btn>
              </v-col>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template> -->

    <!--dialog Product-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogProduct"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="product"
              :headers="headersProduct"
              :items="arrProductGroup"
              :search="search"
              item-key="PRODUCT_GROUP"
              show-select
              class="elevation-1"
              disable-pagination
              hide-default-footer
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will submit all data which is imported to database. Please give
          confirmation before you submit.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";
//import { SurveyBuilder, QuestionsView } from 'vue-survey-builder';
import { SurveyBuilder, QuestionsView } from '../../lib/vue-survey-builder';

const JSON_FOR_DOWNLOAD = [
  {
    CUSTOMER_ID_REF: "",
    CUSTOMER_NAME: "",
    ORG_ID: ""
  },
];

let sampleQuestionObj = {
  "id": null,
  "question": null,
  "type": null,
  "multiSelect": false,
  "characterLimited": false,
  "hasMinMax": false,
  "allowDecimals": false,
  "sequence": null,
  "minValue": 1,
  "maxValue": 8,
  "labels": [],
  "dateFormat": "MM/DD/YYYY",
  "timeFormat": "12",
  "intervals": 2,
  "textLimit": 1024,
  "units": null,
  "options": [
    {
      "body": null,
      "sequence": 1
    },
    {
      "body": null,
      "sequence": 2
    }
  ]
}

export default {
  components: {
    Main,SurveyBuilder, QuestionsView 
  },
  data() {
    const date = new Date();
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      valid: true,
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      isMappingSalesRep: false,
      titlePage: "Input Push Activity",
       itemsTitle: [
        {
          CODE_TITLE :"BJUV",
        },
        {
          CODE_TITLE :"N",
        },
        {
          CODE_TITLE :"FBI",
        },
      ],
      campaignType: "",
      campaignName: "",
      campaignDesc: "",
      bisnis: "",
      empType: "",
      title: "",
      branch: "",
      channel: "",
      product: "",
      arrBisnis: [],
      arrBranch : [],
      arrEmployeeType: [],
      arrProductGroup: [],
      arrTitle: [],
      arrSalesChannelGroup: [],  
      dtItemsSimulation:[],            
      dialogTitle: false,
      dialogBranch: false,
      dialogChannel: false,
      dialogProduct: false,
       dtHeadersBranch: [
        {
          text: "BRANCH CODE",
          value: "BRANCH_CODE",
        },
        {
          text: "TOTAL SALESMAN",
          value: "TotalSALESMAN",
        },
        {
          text: "TOTAL CHANNEL",
          value: "TotalChannel",
        }
      ],
      dtHeadersChannel: [
        {
          text: "BRANCH CODE",
          value: "BRANCH_CODE",
        },
        {
          text: "TOTAL CHANNEL",
          value: "TotalChannel",
        }
      ],
      dtHeadersTitle: [
        {
          text: "TYPE DESC",
          value: "TYPE_DESC",
        },
        {
          text: "TOTAL SALESMAN",
          value: "TotalTitle",
        }
      ],
      arrRow: [],
      questionsList: [],
      addQuestion: false,
      JSON_FILE_UPLOAD: [],
         dtItems: [],
         dates: [],
      menu: false,
      dtLoading:false,
      inputSearch: '',
      search: '',
        headersProduct: [
          { text: 'PRODUCT GROUP', value: 'PRODUCT_GROUP' }
        ],
        headersTitle: [
          { text: "TITTLE CODE", value: "TITTLE_CODE" }
        ],
        headersChannel: [
          { text: 'CHANNEL GROUP', value: 'SALES_CHANNEL_GROUP' }
        ],
        headersBranch: [
          { text: 'BRANCH CODE', value: 'BRANCH_CODE' }
        ],
         singleSelect: false,
         productRead: '',
         seen: true,
         dtItemBranch:[],
         dtItemChannel:[],
         dtItemTitle:[],
         isPicture: '0',
         minDate:  moment(new Date(new Date().getTime()+(2*24*60*60*1000))).toISOString().slice(0,10)
        // minDate: new Date().toISOString().slice(0,10)
    };
  },
   computed: {
    // a computed getter
     reversedMessageChannel: function () {
        if(this.channel.length>0){
          let items = this.channel;
          let arrItem=[];
          items.map(function(item) {
            arrItem.push(item.SALES_CHANNEL_GROUP);
          });
          this.channel = arrItem.toString();
          return arrItem.toString();
        }
    },
     reversedMessageBranch: function () {
       if(this.branch.length>0){
        let items = this.branch;
        let arrItem=[];
        items.map(function(item) {
          arrItem.push(item.BRANCH_CODE);
        });
        this.branch = arrItem.toString();
        return arrItem.toString();
      }
    },
    reversedMessageTitle: function () {
      if(this.title.length>0){
        let items = this.title;
        let arrItem=[];
        items.map(function(item) {
          arrItem.push(item.TITTLE_CODE);
        });
        this.title = arrItem.toString();
        return arrItem.toString();
      }
    },
    reversedMessageProduct: function () {       
        if(this.product.length>0){
          let itemProd = this.product;
          let arrItemProd=[];
          itemProd.map(function(item) {
            arrItemProd.push(item.PRODUCT_GROUP);
          });
          this.product = arrItemProd.toString();
          return arrItemProd.toString();
        }
    },
    dateRangeText () {
      let startDate = this.dates[0];
      let endDate = this.dates[1];
      let start = new Date(startDate); //yyyy-mm-dd
      let end = new Date(endDate); //yyyy-mm-dd
      let newArrDate =[];
      while(start <= end){
        let mm = ((start.getMonth()+1)>=10)?(start.getMonth()+1):'0'+(start.getMonth()+1);
        let dd = ((start.getDate())>=10)? (start.getDate()) : '0' + (start.getDate());
        let yyyy = start.getFullYear();
        let date = yyyy+"-"+mm+"-"+dd; //yyyy-mm-dd
          newArrDate.push(date);
          start = new Date(start.setDate(start.getDate() + 1)); //date increase by 1
      }
      return newArrDate;
    },
  },
  mounted() {
    this.getMasterData();
    this.$root.$on('add-update-question', q => {
      this.updateQuestionsList(q);
    });
  },
  watch: {
  },
  methods: {
    searchProduct(){
      let arrProduct = this.arrProductGroup;
      let inpSearch = this.inputSearch;
      if(arrProduct.some(prod => prod.PRODUCT_GROUP === inpSearch)){
          alert("Object found inside the array.");
      } else{
          alert("Object not found.");
      }
    },
    getMasterData() {
            this.SUMARY_HEADER_CABANG = this.SELECTED_BRANCH;
            let data = {
            };
            this.isLoading = true;
            this.$http
                .post("/pushact/masterdata", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                    if (res.data.success) {
                        this.arrBisnis = res.data.data.resultBisnis;
                        this.arrBranch = res.data.data.resultBranch;
                        this.arrEmployeeType = res.data.data.resultEmployeeType;
                       // this.arrProductGroup = res.data.data.resultProductGroup;
                        this.arrSalesChannelGroup =res.data.data.resultSalesChannelGroup;
                        this.isLoading = false;
                        
                        this.showSnackbar("Get Data Success...");
                    } else {
                        this.isLoading = false;
                        this.isShowData = false;
                        this.showSnackbar(res.data.message);
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    this.isShowData = false;
                    this.showSnackbar(err.toString());
                });
        },
        getTitle() {
            let data = {
              TypeEmp : this.empType
            };
            this.isLoading = true;
            this.$http
                .post("/pushact/gettitle", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                  console.log('gettitle ', res.data.data.resultTitle);
                    if (res.data.success) {
                        this.arrTitle = res.data.data.resultTitle;
                        this.isLoading = false;
                        this.showSnackbar("Get Data Success...");
                    } else {
                        this.isLoading = false;
                        this.isShowData = false;
                        this.showSnackbar(res.data.message);
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    this.isShowData = false;
                    this.showSnackbar(err.toString());
                });
        },
        getProduct() {
            let data = {
              bisnis : this.bisnis.BISNIS_DESC
            };
            this.isLoading = true;
            this.$http
                .post("/pushact/getproduct", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                    console.log('getproduct ', res.data.data.resultProduct);
                    if (res.data.success) {
                        this.arrProductGroup = res.data.data.resultProduct;
                        this.isLoading = false;
                        this.showSnackbar("Get Data Product Success...");
                    } else {
                        this.isLoading = false;
                        this.isShowData = false;
                        this.showSnackbar(res.data.message);
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    this.isShowData = false;
                    this.showSnackbar(err.toString());
                });
        },
    deleteItem(index){
			if (confirm(" Apakah anda yakin akang menghapus data ini?")) {
				this.$delete(this.arrRow, index)
			}
		},
    addRow() {
			this.arrRow.push({
				productID: '',
				productName: '',
				productDesc: '',
				positionFrom: '',
				positionTo: '',
				quantity: '',
				amount: '',
				reason: '',
				arrItem: this.arrInvoice,
				arrPositionFrom: '',
				userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID
				
			});
		},
    onInput(){
      isShowStartDate = false
    },
    getEmailSupervisor() {
      // // console.log(this.supervisor)
      this.emailSupervisor = this.supervisor.SUPERVISOR_EMAIL;
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    showDialogTitle(){
      dialogTitle: true;
    },
     confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
     simulation() {
      this.isLoading = true;
      const userData = JSON.parse(localStorage.getItem("userData"));
      let branch = this.branch;
      let filterBranch = this.arrBranch.filter(function (e){
          return e.BRANCH_CODE == branch;
        }
      );

       let empType = this.empType;
      let filterEmpType = this.arrEmployeeType.filter(function (e){
          return e.EMPLOYEE_TYPE_CODE == empType;
        }
      );
     

        //if(empType && type && branch && startDate && endDate) {
          const data = {
            empTypeId: filterEmpType[0].EMPLOYEE_TYPE_ID,
            bisnis: this.bisnis.BISNIS_DESC,
            typeDesc: this.title[0],
            orgId: filterBranch[0].ORG_ID,
            salesChannel: this.channel[0]
          };
          console.log('data ', data)
          this.$http
            .post("/pushact/simulation", data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              let data = res.data.data
              this.isLoading = false;
              if (res.data.success) {
                this.dtItemBranch=data.resultSimulationPAByBranch;
                this.dtItemChannel=data.resultSimulationPAByChannel;
                this.dtItemTitle=data.resultSimulationPAByTittle;
              } else {
                this.showSnackbar(res.data.message);
              }
              
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
        // } else {
        //   this.isLoading = false;
        //   this.showSnackbar("All Field Must Filled");
        // }
    },
    submit() {
      this.isLoading = true;
      this.isOpenModalConfirm = false;      
      const userData = JSON.parse(localStorage.getItem("userData"));

      let title = this.title;
      let arrChooseTitle = [];
      const title_array = title.split(',');
     for(let i = 0; i < title_array.length; i++){
         let filterTitle = this.arrTitle.filter(function (e){
              return e.TITTLE_CODE == title_array[i];
            }
          );
          let titleID=filterTitle[0].TITTLE_ID;
        arrChooseTitle.push({"TITTLE_ID":titleID,"TITTLE_CODE":title_array[i]});
      }      

       let empType = this.empType;
      let filterEmpType = this.arrEmployeeType.filter(function (e){
          return e.EMPLOYEE_TYPE_CODE == empType;
        }
      );
      let branch = this.branch;
      let arrChooseBranch = [];
       const branch_array = branch.split(',');
      for(let i = 0; i < branch_array.length; i++){
          let filterBranch = this.arrBranch.filter(function (e){
              return e.BRANCH_CODE == branch_array[i];
            }
          );
          let ORG_ID=filterBranch[0].ORG_ID;
         arrChooseBranch.push({"ORG_ID":ORG_ID,"BRANCH_CODE":branch_array[i]});
      }

       let channel = this.channel;
      let arrChooseChannel = [];
       const channel_array = channel.split(',');
      for(let i = 0; i < channel_array.length; i++){
         arrChooseChannel.push(channel_array[i]);
      }

      let product = this.product;
      let arrChooseProduct = [];
       const product_array = product.split(',');
      for(let i = 0; i < product_array.length; i++){
         arrChooseProduct.push({"PRODUCT_GROUP":product_array[i]});
      }

        if (this.campaignName && this.campaignDesc && this.bisnis.BISNIS_MASTER_ID!=undefined && arrChooseTitle.length>0 && arrChooseBranch.length>0 && this.channel && this.questionsList.length > 0) {
          const data = {
            campaignName: this.campaignName,
            campaignDesc: this.campaignDesc,
            bisnis: this.bisnis.BISNIS_MASTER_ID,
            dates: this.dateRangeText,
            empType: filterEmpType[0].EMPLOYEE_TYPE_ID,
            title: arrChooseTitle,
            branch: arrChooseBranch,
            channel: arrChooseChannel,
            product: arrChooseProduct,
            custPA: this.dtItems,
            userIdUpdate: userData.USER_ID,
            questionsList: this.questionsList,
            status: 'New Request',
            ispicture: this.isPicture
          };
          console.log('data insert ', data)

          this.$http
            .post("/pushact/insertpa", data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              if (res.data.success) {
                console.log('res.data ', res.data)
                this.isLoading = false;
                this.showSnackbar(res.data.message);
                this.$router.push({
                  name: "PAOverview",
                });
              } else {
                this.isLoading = false;
                this.showSnackbar(res.data.message);
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
        } else {
          this.isLoading = false;
          this.showSnackbar("All Field Must Filled");
        }
     },
    onAddFiles(event) {
      try {
        let self = this;
        let file = event;
        const userData = JSON.parse(localStorage.getItem("userData"));
        const reader = new FileReader();
        this.dtItems = [];
        reader.onload = (e) => {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
            cellDates: true,
          });

          //console.log("file.type : ", file.type);

          let sheetName = workbook.SheetNames[0];
          /* DO SOMETHING WITH workbook HERE */
          let worksheet = workbook.Sheets[sheetName];
          const XLSXJSON = XLSX.utils.sheet_to_json(worksheet);
          for (let XLSXJSONDATA of XLSXJSON) {
            if (
              XLSXJSONDATA.CUSTOMER_ID_REF != undefined &&
              XLSXJSONDATA.CUSTOMER_NAME != undefined &&
              XLSXJSONDATA.ORG_ID != undefined
            ) {
              this.isLoading = true;
              if (file.type == "application/vnd.ms-excel" || file.type ==
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                self.dtItems.push({
                  CUSTOMERIDREF: XLSXJSONDATA.CUSTOMER_ID_REF,
                  CUSTOMERNAME : XLSXJSONDATA.CUSTOMER_NAME,
                  ORGID: XLSXJSONDATA.ORG_ID
                });
              } else {
                self.showSnackbar("Gunakan template XLSX");
              }
            }
          }
          console.log('self.dtItems. ', self.dtItems);
          this.isLoading = false;
          if (self.dtItems.length > 0) {
            self.showSnackbar("Template valid");
          } else {
            self.showSnackbar("Gunakan template XLSX");
          }
        };

        if (file) {
          reader.readAsArrayBuffer(file);
        }
      } catch (e) {
        this.isLoading = false;
        this.isOpenModalConfirm = false;
        this.showSnackbar(e);
      }
    },
    updateQuestionsList(question) {
      const questionIndex = this.questionsList.findIndex(x => x.id === question.id);
      if (questionIndex >= 0) {
        this.questionsList.splice(questionIndex, 1, question);
      } else {
        this.questionsList.push(JSON.parse(JSON.stringify(question)));
      }
      this.addQuestion = false;
      this.$root.$emit('selected-question', null);
      window.console.log(question, this.addQuestion, this.questionsList);
    },
    addNewQuestion() {
      this.sampleQuestion = JSON.parse(JSON.stringify(sampleQuestionObj));
      this.addQuestion = true;
    },
    downloadCSV() {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(JSON_FOR_DOWNLOAD);
      XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1"); // add the worksheet to the book
      XLSX.writeFile(workBook, "Template upload customer.xlsx"); // initiate a file download in browser
    },
  },
};
</script>

<style scoped>
.add_another_btn {
  font-size: 14px;
  background-color: transparent;
  border-color: #4c8ce4;
  color: #4c8ce4;
  padding: 8px;
  cursor: pointer;
}
.text-center {
  text-align: center;
}
.row{
  margin-left:0px;
  margin-top:5px;
}
.marginLeft{
  margin-left:10px;
}
</style>